import { InitService } from './init.service';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { AdminHttpProxyService } from './admin-http-proxy.service';
import { environment } from 'environments/environment';
import { CookiesService } from './cookies.service';
import * as _ from 'lodash';
@Injectable({
  providedIn: 'root',
})
export class AdminLoginService {
  public cloudDomain: any;
  public platformDomain: any;
  public tenant: any = '';
  public cloudContextTenants: any;
  cloudContextTenents: any;
  appName: string;
  public propertyService: string = 'wbe-property-service';
  isLoginSubmited: BehaviorSubject<boolean> = new BehaviorSubject(false);
  adsamlToken: string;
  logoutHtmlContent: any;
  constructor(
    public _http: HttpClient,
    public router: Router,
    public InitService: InitService,
    public httpService: AdminHttpProxyService,
    public cookies: CookiesService
  ) {}

  public loginUser(userId, password, tenant) {
    let body = {
      username: userId,
      password: password,
    };
    let url = `${environment.backendApiUrl}/wbe-admin-service/login/tenants/${tenant}`;
    let headerOptions = this.InitService.serviceHeaders;
    return this.httpService.post(url, body, headerOptions).pipe(
      tap((data) => {
        if (data['token']) {
          this.storeLoginDetails(data);
        }
      })
    );
  }

  getLoginDetail(tenant) {
    let url = environment.backendApiUrl + '/wbe-admin-service/login/tenants/' + tenant + '/details';
    let headerOptions = this.InitService.serviceHeaders;
    return this.httpService.get(url, headerOptions).pipe(tap((data) => this.mergeAndStoreProperties(data)));
  }

  changePassword(data) {
    let headers = this.getHeaders();
    let { tenantId, user, body } = data;
    let url = environment.backendApiUrl + '/wbe-admin-service/login/tenants/' + tenantId + '/users/' + user + '/password';
    let headerOptions = this.InitService.serviceHeaders;
    return this.httpService.put(url, body).pipe(tap((data) => this.mergeAndStoreProperties(data)));
  }

  private mergeAndStoreProperties(data: any) {
    if (data?.['token']) {
      const sessionData = _.cloneDeep(data);
      const existingProperties = sessionData?.['tenants']?.existingProperties || [];
      const newProperties = sessionData?.['tenants']?.newProperties || [];
      const allProperties = [...existingProperties, ...newProperties];
      sessionData['tenants']['properties'] = allProperties;
      delete sessionData?.['tenants']?.existingProperties;
      delete sessionData?.['tenants']?.newProperties;
      sessionStorage.setItem('userDetails', JSON.stringify(sessionData));
      sessionStorage.setItem('newUserDetails', JSON.stringify(data));
    }
  }

  getRandomSecurityQuestion(username, tenantId) {
    let url =
      environment.backendApiUrl + '/wbe-admin-service/user-service/tenants/' + tenantId + '/users/' + username + '/randomsecurityquestions';
    return this.httpService.get(url);
  }

  forgotPassword(username, tenantId, data) {
    let url =
      environment.backendApiUrl +
      '/wbe-admin-service/user-service/tenants/' +
      tenantId +
      '/users/' +
      username +
      '/sendmessageforgotpassword';
    return this.httpService.post(url, data);
  }

  forgotUsername(data) {
    let url = environment.backendApiUrl + '/wbe-admin-service/user-service/tenants/null/sendmessageforgotusername';
    return this.httpService.post(url, data);
  }

  sendMessageTwoFactorCode(username, tenantId) {
    let url =
      environment.backendApiUrl +
      '/wbe-admin-service/user-service/tenants/' +
      tenantId +
      '/users/' +
      username +
      '/sendmessagesecondfactorcode';
    return this.httpService.post(url, null);
  }

  sendEmailTwoFactorCode(username, tenantId) {
    let url =
      environment.backendApiUrl +
      '/wbe-admin-service/user-service/tenants/' +
      tenantId +
      '/users/' +
      username +
      '/sendemailsecondfactorcode';
    return this.httpService.post(url, null);
  }

  validateTwoFactorCode(tenantId, data) {
    let headers = this.getHeaders();
    data['token'] = this.getToken();
    let url = environment.backendApiUrl + '/wbe-admin-service/login/tenants/' + tenantId + '/logincode';
    return this.httpService.post(url, data, { headers });
  }

  public handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }

  getAdminConfigDetails(callbackFunction) {
    if (this.cloudDomain) this.InitService.checkDomain();
    callbackFunction();
  }

  getHeaders() {
    let token = sessionStorage.getItem('token') || '';
    let headers = new HttpHeaders({
      'X-Token': token,
    });
    return headers;
  }

  getToken() {
    return sessionStorage.getItem('token') || '';
  }

  resolve(): any {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('adsamlToken');
    this.cookies.deleteTokenCookie('BookAdmin-Token', -1);
    sessionStorage.removeItem('environment');
    sessionStorage.removeItem('tenant');
    sessionStorage.removeItem('adminPortalLoginData');
    sessionStorage.removeItem('loginTimestamp');
    sessionStorage.removeItem('userDetails');

    return new Promise((resolve, reject) => {
      this.getAdminConfigDetails(() => {
        resolve(true);
        var preloader = document.querySelector('.preloaderapp');
        if (preloader) {
          preloader.className = ' preloaderapp-hidden-add preloaderapp-hidden-add-active';
        }
      });
    });
  }

  getMapAPIKey(tenantId): Observable<any> {
    let headerOptions = this.InitService.serviceHeaders;
    return this.httpService
      .get(
        environment.backendApiUrl +
          '/' +
          this.propertyService +
          '/azuredetails/tenants/' +
          sessionStorage.getItem('tenant') +
          `/account/googleaddress/getDetail`,
        headerOptions
      )
      .pipe(tap((data) => console.log(data)));
  }

  getHtmlTemplate(tenantId) {
    const url = environment.backendApiUrl + '/wbe-admin-service/login/tenants/' + tenantId + '/adsaml';
    return this._http.get(url, { responseType: 'text' });
  }

  checkIsAdsamlConfigured(tenantId) {
    const url = environment.backendApiUrl + '/wbe-admin-service/login/tenants/' + tenantId + '/isAdsamlConfigured';
    return this.httpService.get(url);
  }

  loginSSO() {
    const tenantId = sessionStorage.getItem('ssoTenantId');
    const ssoHeaders = {
      headers: {
        'SAML-Token': this.adsamlToken,
      },
    };
    const url = environment.backendApiUrl + '/wbe-admin-service/login/tenants/' + tenantId;
    return this.httpService.get(url, ssoHeaders).pipe(
      tap((data) => {
        if (data['token']) {
          this.storeLoginDetails(data);
        }
      })
    );
  }

  storeLoginDetails(data) {
    if (data['token']) {
      const sessionData = _.cloneDeep(data);
      const existingProperties = sessionData?.['tenants']?.existingProperties;
      const newProperties = sessionData?.['tenants']?.newProperties;
      const allProperties = [...existingProperties, ...newProperties];
      sessionData['tenants']['properties'] = allProperties;
      delete sessionData?.['tenants']?.existingProperties;
      delete sessionData?.['tenants']?.newProperties;
      let isServiceAccount = sessionData['tenantList'] ? sessionData['tenantList'].length > 0 : false;
      let userSessionKey = isServiceAccount ? 'serviceUserDetails' : 'userDetails';
      sessionStorage.setItem('isServiceAccount', JSON.stringify(isServiceAccount));
      sessionStorage.setItem(userSessionKey, JSON.stringify(sessionData));
      sessionStorage.setItem('newUserDetails', JSON.stringify(data));
    }
  }
}
